var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorymdInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Component 5683 \\u2013 34",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#dffafb",
    "data-name": "Ellipse 4928"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53508"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17268"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15285",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1aa9b4",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 0.66,
    d: "M7.366 8.718h-2.61V6.706h2.61V4.082h2.047v2.624h2.61v2.012h-2.61v2.624H7.366Z",
    "data-name": "Path 18565"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M15.643 9.403a3.975 3.975 0 0 0-3.533 1.87.494.494 0 0 0 .106.675l.885.672a.492.492 0 0 0 .682-.085 1.991 1.991 0 0 1 1.7-1.016c.631 0 1.412.407 1.412 1.02 0 .463-.382.7-1.006 1.051-.726.413-1.688.913-1.688 2.187v.2a.493.493 0 0 0 .493.493h1.487a.493.493 0 0 0 .493-.493v-.118c0-.881 2.571-.917 2.571-3.3-.001-1.795-1.86-3.156-3.602-3.156Zm-.206 7.673a1.423 1.423 0 1 0 1.422 1.427 1.424 1.424 0 0 0-1.422-1.427Z",
    "data-name": "Icon awesome-question"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorymdInfo);
export default __webpack_public_path__ + "static/media/storymd-info.f174d1d962132c49087fd5064b7b3494.svg";
export { ForwardRef as ReactComponent };